import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CustomTextArea = React.memo(({ item }) => {
    const { name, label, type, autoComplete, id, value, onChange, placeholder, required, hint, error, minLength, pattern, onBlur } = item;

 
    return (
        <div>
            <label htmlFor={name} className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                {label}
            </label>
            <div className="relative">
                <textarea
                    type={type}
                    autoComplete={autoComplete}
                    id={id}
                    name={name}
                    value={value || ''}
                    onChange={onChange}
                    onBlur={onBlur}
                    placeholder={placeholder}
                    className={clsx(
                        'w-full px-3 py-2',
                        'border border-gray-300 dark:border-gray-600',
                        'rounded-lg',
                        'placeholder:text-gray-400 dark:placeholder:text-gray-500 placeholder:text-sm',
                        'focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400',
                        'bg-white dark:bg-gray-700',
                        'text-gray-900 dark:text-white'
                    )}
                    required={required}
                    title={hint}
                    minLength={minLength}
                    pattern={pattern}
                />
                
            </div>
            {(hint || error) && <p className={clsx('mt-1 text-xs', error ? 'text-red-500 dark:text-red-400' : 'text-gray-500 dark:text-gray-400')}>{error || hint}</p>}
        </div>
    );
});

CustomTextArea.displayName = 'CustomInput';

CustomTextArea.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        autoComplete: PropTypes.string,
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        hint: PropTypes.string,
        minLength: PropTypes.number,
        pattern: PropTypes.string,
        isToogleButton: PropTypes.bool
    }).isRequired,
    showPassword: PropTypes.bool,
    togglePasswordVisibility: PropTypes.func
};

export default CustomTextArea;
